import { useEffect, useRef } from 'react';

import dash_api from '../../support/dash_api';
import type { MicroFrontend } from '../../../../../shared/types/microFrontend.types';

const updatePrometheusLoadHistogram = async (microFrontend: MicroFrontend, elapsedTime: number) => {
  try {
    await dash_api.post(`/v1/micro-frontends/analytics/loads/${microFrontend}`, { load: elapsedTime });
  } catch (error) {
    throw error;
  }
};

export const useMicroFrontendLoadAnalytics = (isMicroFrontendReady: boolean, microFrontend: MicroFrontend): void => {
  const startTimeRef = useRef<number>(0);

  useEffect(() => {
    if (!isMicroFrontendReady) {
      startTimeRef.current = new Date().getTime();
    } else {
      const endTime = new Date().getTime();

      const elapsedTime = endTime - startTimeRef.current;

      updatePrometheusLoadHistogram(microFrontend, elapsedTime);
    }
  }, [isMicroFrontendReady, microFrontend]);
};
